import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramActivityRowFragment on ComplianceProgramActivityRowNode {
    id
    verb
    source
    batch
    isBatch
    created
    firstCreated
    channel
    status
    error
    payload
    notificationType
    notificationLabel
    unknownCount
    acceptedCount
    sentCount
    failedCount
    skippedCount
    rowCount
    actor {
      id
      name
      avatar
    }
    target {
      id
      name
      avatar
    }
  }

  query getComplianceProgramActivity(
    $complianceProgramId: Int!
    $verbPrefixIn: [String]
    $after: String
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      created
      activity(verbPrefixIn: $verbPrefixIn, first: 50, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...ComplianceProgramActivityRowFragment
          }
        }
      }
    }
  }
`;
